export const SUCCESS = "SUCCESS";
export const APPROVED = "APPROVED";
export const MINED = "MINED";
export const PENDING = "PENDING";
export const MINING = "MINING";
export const FAIL = "FAIL";
export const REJECTED = "REJECTED";
